import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import proximaNovaRegular from "./Assets/Fonts/ProximaNova-Regular.woff";
import proximaNovaSemibold from "./Assets/Fonts/ProximaNova-Semibold.woff";
import proximaNovaMedium from "./Assets/Fonts/ProximaNova-Medium.woff";
import proximaNovaSoftSemibold from "./Assets/Fonts/ProximaNovaSoft-Semibold.woff";
import proximaNovaSoftMedium from "./Assets/Fonts/ProximaNovaSoft-Medium.woff";
import proximaNovaSoftBold from "./Assets/Fonts/ProximaNovaSoft-Bold.woff";
import proximaNovaSoftRegular from "./Assets/Fonts/ProximaNovaSoft-Regular.woff";
import { CssBaseline } from "@mui/material";

const root = ReactDOM.createRoot(document.getElementById("root"));
const theme = createTheme({
  typography: {
    fontFamily:
      "ProximaNova, ProximaNovaMedium, ProximaNovaSemibold, ProximaNovaSoftSemibold, ProximaNovaSoftBold, ProximaNovaSoftMedium, ProximaNovaSoftRegular",
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
					@font-face 
						{
						font-family: 'ProximaNova';
						font-style: normal;
						font-display: swap;
						src: local('ProximaNova'), local('ProximaNova-Regular'), url(${proximaNovaRegular}) format('woff');
						unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
					}
					@font-face 
						{
						font-family: 'ProximaNovaMedium';
						font-style: normal;
						font-display: swap;
						src: local('ProximaNovaMedium'), local('ProximaNova-Regular'), url(${proximaNovaMedium}) format('woff');
						unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
					}
					@font-face {
						font-family: 'ProximaNovaSemibold';
						font-style: normal;
						font-display: swap;
						src: local('ProximaNovaSemibold'), local('ProximaNova-Semibold'), url(${proximaNovaSemibold}) format('woff');
						unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
					}
					@font-face {
						font-family: 'ProximaNovaSoftSemibold';
						font-style: normal;
						font-display: swap;
						src: local('ProximaNovaSoftSemibold'), local('ProximaNovaSoft-Semibold'), url(${proximaNovaSoftSemibold}) format('woff');
						unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
					}
					@font-face {
						font-family: 'ProximaNovaSoftMedium';
						font-style: normal;
						font-display: swap;
						src: local('ProximaNovaSoftMedium'), local('ProximaNovaSoft-Medium'), url(${proximaNovaSoftMedium}) format('woff');
						unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
					}
					@font-face {
						font-family: 'ProximaNovaSoftBold';
						font-style: normal;
						font-display: swap;
						src: local('ProximaNovaSoftBold'), local('ProximaNovaSoft-Bold'), url(${proximaNovaSoftBold}) format('woff');
						unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
					}
					@font-face {
						font-family: 'ProximaNovaSoftRegular';
						font-style: normal;
						font-display: swap;
						src: local('ProximaNovaSoftRegular'), local('ProximaNovaSoft-Regular'), url(${proximaNovaSoftRegular}) format('woff');
						unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
					}
				
				`,
    },

		MuiDialog: {
			defaultProps: {
				maxWidth: "xs",
				fullWidth: true,
			}
		},
		MuiDialogTitle: {
			defaultProps: {
				fontSize: 18,
				fontFamily: "ProximaNovaSoftSemibold",
				color: "secondary.main",
				padding: "16px 24px 8px 24px !important"
			}
		},
		MuiDialogContentText: {
			defaultProps: {
				fontSize: 16,
				fontFamily: "ProximaNovaMedium",
				color: "darkGray.main",
			}
		},

		MuiDialogActions: {
			defaultProps: {
				fontSize: 18,
				fontFamily: "ProximaNovaSoftSemibold",
			}
		},
		MuiButtonBase: {
			defaultProps: {
				sx:{
					fontFamily: "ProximaNovaSoftSemibold !important",
					fontSize: "16px !important",
					lineHeight: "1.25 !important",
					borderRadius: "4px"
				}
			}
		}
  },

  palette: {
    primary: { main: "#0074BF" },
    light: { main: "#C5E8F6" },
    secondary: { main: "#004579" },
    background: { main: "#ffffff" },
    gray: {
      main: "#767676",
    },
    lightGray: {
      main: "#AEAEAE",
    },
    darkGray: {
      main: "#58595B",
    },
    black: {
      main: "#2E2E2E",
    },
		success: {
      main: '#388e3c',
		}
  },
});

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
